export default class TemplateEditCtrl {
    constructor($scope, $filter, $state, $timeout, $stateParams, $rootScope, SideMenu, Template, Events, SweetAlert, Sogeti) {
        SideMenu.setActive('template');

        this._scope = $scope;
        this._timeout = $timeout;
        this._translator = $filter('translate');
        this._filter = $filter;
        this._state = $state;
        this._stateParams = $stateParams;

        this.alerter = SweetAlert;
        this.templateRepo = Template;
        this.eventHandler = Events;
        this.sogeti = Sogeti;

        this.htmlSource = false;
        this.templateId = $stateParams.id;
        this.imageBankVisible = false;
        this.thumbnailFile = false;
        this.template = {
            templateImages: []
        };

        this.templateRepo.get(this.templateId).then((template) => {
            this.template = template.data;
            this.htmlSource = 'template/' + this.templateId + '/htmlContent';
            this.plainSource = 'template/' + this.templateId + '/plainContent';
            this.isSogetiAccount = Sogeti.isSogetiAccount(this.template.account_id);

            this._scope.$broadcast('mailEditor:htmlSource:template', this.htmlSource);
            this._scope.$broadcast('plainContent:fetchHistoricalVersion', this.plainSource);
        });

        this.templateRepo.findAllTypes().then((types) => {
            this.templateTypes = [];

            angular.forEach(types, (templateType) => {
                if (templateType.id > 100) {
                    this.templateTypes.push(templateType);
                }
            });
        });

        this._scope.$watch('thumbnailFile', (newVal, oldVal) => {
            if (newVal !== false && newVal != oldVal) {
                this.alerter.swal({
                    title: this._translator('TEMPLATE:EDIT:THUMBNAIL_UPLOAD_HEADER').replace('/:name/', newVal.name),
                    text: this._translator('TEMPLATE:EDIT:THUMBNAIL_UPLOAD_BODY').replace('/:name/', newVal.name),
                    type: "warning",
                    showCancelButton: true
                }, (isConfirmed) => {
                    if (isConfirmed) {
                        this.updateThumbnail(newVal);
                    }
                });
            }
        });

        this._scope.$on('mailEditor:content:loaded', () => {
            this._timeout(() => { // Pass back to editor to insert CKEditor into the entire template.
                this._scope.$broadcast('template:editor:loaded');
            });
        });

        this._scope.$on('template:refreshImages', () => {
            this.templateRepo.get(this.templateId).then((template) => {
                this.template.templateImages = template.data.templateImages;
            });
        });

        this._scope.$on('sogeti:largeImage:updated', () => {
            this.update();
        });

        this._scope.$on('account:changed', () => {
            this._state.go('template.index');
        });
    }

    toggleImageBank() {
        this.imageBankVisible = ! this.imageBankVisible;
        this._scope.$emit('imageBank:toggle');
    }

    sendUpdateRequest(id, html, plain, name) {
        let template = {
            id: id,
            html: this._filter('b64encode')(html),
            plain: this._filter('b64encode')(plain),
            name: name,
            typeId: this.getTemplateTypeId()
        };

        this.templateRepo.update(template).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('TEMPLATE:EDIT:SAVED'));
        }, (error) => {
            if (error.status == 400 && error.data == 'ValidationError') {
                angular.forEach(Object.keys(error.data.message), (validationError) => {
                    if (validationError == 'plain') {
                        this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:EMPTY_PLAIN_CONTENT'));
                    }
                    // Add handlers for other keys here..
                });
            }
        });
    };

    updateThumbnail(thumbnail) {
        this.templateRepo.uploadThumbnail(this.template, thumbnail).then((res) => {
            this.eventHandler.flashEvent('notification', this._translator('TEMPLATE:EDIT:THUMBNAIL_SAVED'));
            this.template.thumbnail = res.data.thumbnail;
        });
    };

    update() {
        this._scope.$broadcast('plainEditor:getContent', (plain) => {
            this.templateRepo.get(this.template.id).then((res) => {
                let makeUpdate = (html) => {

                    if (this.isSogetiAccount && this.getTemplateTypeId()) {
                        if (!this.sogeti.templateHasAllRequiredImages(res.data)) {
                            this.eventHandler.flashEvent('error', this._translator('TEMPLATE:EDIT:NO_IMAGES_ERROR'));
                        } else if (!this.sogeti.templateHasAllRequiredBlocks(html)) {
                            this.eventHandler.flashEvent('error', this._translator('TEMPLATE:EDIT:NO_BLOCKS_ERROR'));
                        }
                    }

                    return this.sendUpdateRequest(
                        this.template.id,
                        html,
                        plain,
                        this.template.name,
                        this.template.thumbnail
                    );
                };

                this._scope.$broadcast('template:updateHtml', makeUpdate);
            });
        }); 
    };

    sendCreateRequest(html, plain, name) {
        return this.templateRepo.store({
            html: this._filter('b64encode')(html),
            plain: this._filter('b64encode')(plain),
            name: name,
            typeId: this.getTemplateTypeId()
        });
    };
    
    saveAs() {
        this.alerter.swal({
                title: this._translator('TEMPLATE:EDIT:SAVE_AS'),
                text: this._translator('TEMPLATE:EDIT:SAVE_AS_BODY'),
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: true,
                inputPlaceholder: "New Template"
            }, (inputValue) => {
                if (inputValue === false) {
                    return false;
                } else if (inputValue === "") {
                    swal.showInputError(this._translator('TEMPLATE:EDIT:NO_NAME_ERROR'));
                    return false;
                }
                
                this._scope.$broadcast('plainEditor:getContent', (plain) => {
                    let saveAsNew = (html) => {
                        this.sendCreateRequest(html, plain, inputValue).then((res) => {
                            this._state.go('template.edit', { id: res.data.id });
                        });
                    };
                    this._scope.$broadcast('template:updateHtml', saveAsNew);
                }); 

                return true;
            });
    };

    openPreview() {
        window.open('/template/' + this.templateId + '/preview');
    };

    getTemplateTypeId() {
        return this.template.hasOwnProperty('templateType') ? this.template.templateType.data.id : null;
    }
};
